module.exports = require('./lib/operators')



//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/router/operators.js
// module id = 810
// module chunks = 1